<template>
  <div>
    <s1vm-user-panel></s1vm-user-panel>
    <md-app class="s1-md-app">
      <md-app-drawer class="md-xsmall-hide md-small-hide" :md-active.sync="menuVisible" md-persistent="mini">
        <div class="s1-logo__wrapper" @click="toggleMenu">
          <img class="s1-logo__img" src="https://s1vm.netlify.com/logo.svg" alt="company logo">
        </div>
        <s1vm-menu :visible.sync="menuVisible" @toggle="toggleMenu"></s1vm-menu>
      </md-app-drawer>

      <md-app-content class="s1-loc__body-bg">
        <slot></slot>
      </md-app-content>
    </md-app>
  </div>
</template>
<script>
export default {
  data: () => ({
    menuVisible: false
  }),
  methods: {
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    }
  }
}
</script>
